<!--AFFICHAGE BLOC HEADER -->
<template>
  <v-layout v-if="this.condition()">


    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
            large
            left
            v-bind="attrs"
            v-on="on"
        >
          {{ nature }}
        </v-icon>
      </template>
      <span>{{ tooltipNature }}</span>
    </v-tooltip>
    <v-toolbar-title> {{ this.nom }}<br>Créée le {{ this.cree }} - {{ this.detail }}</v-toolbar-title>


    <v-spacer></v-spacer>
    <v-divider
        class="mx-4"
        vertical
    ></v-divider>
    <span>Siren : {{ this.identite.siren.valeur }}<br>Siret : {{ this.identite.siret.valeur }}</span>
    <v-divider
        class="mx-4"
        vertical
    ></v-divider>
  </v-layout>

</template>


<script>


export default {
  name: 'EtabToolbar',
  props: ['etablissement'],
  components: {},
  computed: {
    identite: function () {
      return this.$store.getters.getbloc("identite", "donnees")
    },
    nom: function () {
      return this.$store.getters.getbloc("identite", "donnees").nom.valeur
    },
    detail: function () {
      return this.$store.getters.getbloc("administratif", "donnees", "categorieJuridiqueUniteLegaleNiv1", "").libelle
    },
    cree: function () {
      return this.$store.getters.getbloc("administratif", "donnees", "dateCreationEtablissement", "1900-01-01").libelle
    },
    pp: function () {
      return this.$store.getters.getbloc("identite", "donnees").nature.valeur == "PP"
    },
    pm: function () {
      return this.$store.getters.getbloc("identite", "donnees").nature.valeur == "PM"
    },
    siege: function () {
      return this.$store.getters.getbloc("administratif", "donnees").etablissementSiege.valeur == "true" && this.pm
    },


    defaillance: function () {
      var defaillance = this.$store.getters.getbloc("finance", "indicateurs", "defaillanceGratuit")
      if (defaillance != null && defaillance.libelle != null && defaillance.libelle != "") {
        return defaillance.libelle
      }
      return ""
    },

    nature: function () {
      if (this.$store.getters.getbloc("identite", "donnees", "nature", null, "valeur") == "PP") {
        return (this.$store.getters.getbloc("administratif", "donnees", "etablissementSiege", null, "valeur") == "true" ? "mdi-account-star" : "mdi-account")
      } else {
        return (this.$store.getters.getbloc("administratif", "donnees", "etablissementSiege", null, "valeur") == "true" ? "mdi-office-building-marker-outline" : "mdi-office-building-outline")
      }
    },
    tooltipNature: function () {
      if (this.$store.getters.getbloc("identite", "donnees", "nature", null, "valeur") == "PP") {
        return (this.$store.getters.getbloc("administratif", "donnees", "etablissementSiege", null, "valeur") == "true" ? "Personne physique (Siège)" : "Personne physique (établissement secondaire)")
      } else {
        return (this.$store.getters.getbloc("administratif", "donnees", "etablissementSiege", null, "valeur") == "true" ? "Personne morale (Siège)" : "Personne morale (etablissement secondaire)")
      }
    }

  },
  methods: {
    condition() {
      return this.$store.getters.condition("identite", "donnees")
    },
  }
};
</script>